module.exports = __webpack_public_path__ + "static/media/01.7a49ffcf.png";